import { APP_WILL_MOUNT } from '../base/app/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { SET_PARTICIPANTS_LAYOUT } from './actionTypes';
import { applyParticipantsLayoutToDom, getParticipantsLayout } from './functions';
/**
 * Keeps the <html> `data-participants-layout` attribute in sync with the
 * persisted selection so the themed CSS can arrange participants.
 *
 * @param {IStore} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case APP_WILL_MOUNT:
            applyParticipantsLayoutToDom(getParticipantsLayout(store.getState()));
            break;
        case SET_PARTICIPANTS_LAYOUT:
            applyParticipantsLayoutToDom(action.layout);
            break;
    }
    return next(action);
});
